import { requestApi } from '@app/api';
import { withNotification } from '@app/api/paths';

export interface GetBusinessCategoryResponse {
  categories: Array<{
    parentCode: string;
    depth: number;
    code: string;
    name: string;
    subCategories: Array<{
      parentCode: string;
      depth: number;
      code: string;
      name: string;
      subCategories: Array<{
        parentCode: string;
        depth: number;
        code: string;
        name: string;
      }>;
    }>;
  }>;
}

// eslint-disable-next-line import/prefer-default-export
export function getBusinessCategories() {
  return requestApi<GetBusinessCategoryResponse>({
    url: withNotification('/kakao-channel/business-categories'),
    method: 'GET',
    credentials: true,
  }).then(({ data }) => data);
}
